import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Attendee } from '../../../core/models/event.models';

@Component({
  selector: 'app-event-attendees',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './event-attendees.component.html',
})
export class EventAttendeesComponent {
  @Input({ required: true }) attendees!: Attendee[];
  track = (_: number, a: Attendee) => a.id;
}
